module.exports = __webpack_public_path__ + "img/geniepopup.62c221ba.png";